import React from 'react';
import type { ReviewItem } from '@/types/api';
import { LayoutReviewsBody } from '../../_layouts/LayoutsReviewsBody';
import ReviewsContent from './ReviewsContent';
import { useReviews } from './ReviewsProvider';

import { Button } from '@/components/atoms/PcButton';
import { useNavigate } from 'react-router-dom';
import EmptyFaceIcon from '@/assets/icons/EmptyFaceIcon.svg?react';
import NotRegisteredState from '../common/NotRegisteredState';

interface ReviewsBodyProps {
  reviews: ReviewItem[];
  allMarketsQueries: any; // Adjust type as necessary
}

const ReviewsBody: React.FC<ReviewsBodyProps> = ({ reviews, allMarketsQueries }) => {
  const { currentTab, marketList } = useReviews();
  const navigate = useNavigate();

  // 1. 연동된 마켓이 없는 경우
  // if (!marketList || marketList.length === 0) {
  if (!marketList || marketList.length === 0) {
    return <NotRegisteredState />;
  }

  // 2. 리뷰가 없는 경우
  if (!reviews.length) {
    let emptyText = '리뷰가 없습니다';
    if (currentTab === 'whole' || currentTab === 'not-yet') {
      emptyText = '처리할 리뷰가 없어요';
    } else if (currentTab === 'completed') {
      emptyText = '처리한 리뷰가 없어요';
    }
    return (
      <div className="flex h-full w-full flex-1 flex-col items-center justify-center gap-[20px]">
        <EmptyFaceIcon />
        <div className="text-gr-700 Body1S16">{emptyText}</div>
      </div>
    );
  }

  // 3. 리뷰가 있는 경우
  return (
    <LayoutReviewsBody className="pr-0">
      {reviews.map((review) => (
        <ReviewsContent
          allMarketsQueries={allMarketsQueries}
          review={review}
          key={review.ReviewNo}
        />
      ))}
    </LayoutReviewsBody>
  );
};

export default ReviewsBody;
